<div class="main no-padding">
  <header-menu></header-menu>

  <div class="center-content internal-registration-establishment fade-in-animation">
    <div class="card area-to-overlay ">
      <div class="card-content">
        <header>
          <h1>Cadastro do Negócio</h1>
        </header>

        <h2>Endereços</h2>

        <div class="form-address-my-profile">
          <accordion [showArrows]="true" [closeOthers]="true">
            <accordion-group class="row form col-xs-12 col-md-7" [isOpened]="establishment.addresses[i].isOpenAccordion" [heading]="establishment.addresses[i].nameUnit ? establishment.addresses[i].nameUnit : item.name" *ngFor="let item of establishment.addresses; let i = index">
              <accordion-heading>
                <div *ngIf="i > 0" class="pull-right btn-group btn-group-xs">
                  <a class="btn-remove-address" (click)="removeAddress(i)"><i class="fa fa-close"></i> {{ 'REGISTRATION.ADDRESS.REMOVE_ADDRESS_LABEL' | translate }}</a>
                </div>
              </accordion-heading>
              <div class="row form">
                <div class="col-xs-12 col-md-12">
                  <div class="row">
                    <div class="col-xs-12">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.nameUnit == true}">
                        <label class="label-input">{{ 'REGISTRATION.ADDRESS.UNIT_NAME_LABEL' | translate }}</label>
                        <input [(ngModel)]="establishment.addresses[i].nameUnit" (ngModelChange)="updateAddressErros()" type="text" class="form-control" placeholder="ex.: Unidade Pinheiros">
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-6 col-sm-4">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.cep == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.CEP_LABEL' | translate }}</label>
                        <input [(ngModel)]="establishment.addresses[i].cep" [disabled]=isLoadingCep [textMask]="{mask: cepMask}" type="text" class="form-control" (ngModelChange)="updateAddressErros()" placeholder="" (blur)="cepChange($event, i)">
                      </div>
                    </div>
        
                    <div class="col-xs-12 col-sm-8">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.neighborhood == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.NEIGHBORHOOD_LABEL' | translate }}</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="establishment.addresses[i].neighborhood">
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-9 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.county == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.COUNTY_LABEL' | translate }}</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="establishment.addresses[i].county">
                      </div>
                    </div>
        
                    <div class="col-xs-3 col-sm-6">
                        <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.state == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.STATE_LABEL' | translate }}</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="establishment.addresses[i].state">
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-12">
                        <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.street == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.STREET_LABEL' | translate }}</label>
                        <input type="text" class="form-control" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [(ngModel)]="establishment.addresses[i].street">
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-6 col-sm-6">
                        <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.number == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.NUMBER_LABEL' | translate }}</label>
                        <input [(ngModel)]="establishment.addresses[i].number" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" type="text" class="form-control" placeholder="">
                      </div>
                    </div>
        
                    <div class="col-xs-6 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.additional == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.ADDITIONAL_INFO_LABEL' | translate }}</label>
                        <input [(ngModel)]="establishment.addresses[i].additional" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" type="text" class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>
        
                  <div class="row">
                    <div class="col-xs-8 col-sm-6">
                      <div [ngClass]="{'form-group': true, 'has-error': isShowError && addressErros[i]?.telephone == true}">
                        <label class="label-input">{{ 'REGISTRATION_COMPANY.ADDRESS.PHONE_NUMBER_LABEL' | translate }}</label>
                        <input [(ngModel)]="establishment.addresses[i].telephone" [disabled]=isLoadingCep (ngModelChange)="updateAddressErros()" [textMask]="{mask: telephoneMask}" type="text" class="form-control" placeholder="">
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-xs-8 col-sm-6">
                      <div [ngClass]="{'form-group': true}">
                        <div class="buttons-actions-colab-form" *ngIf="!isLoading">
                          <button class="btn btn-orange-contrast" (click)="updateAddress(i)">Salvar</button>
                        </div>
                      </div>
                    </div>
                  </div>


                </div>
              </div>
            </accordion-group>
          </accordion>
        </div>

        <div class="row">
          <div class="col-xs-12 col-md-7">
            <a (click)="addAddress()" class="end-optional">{{ 'REGISTRATION.ADDRESS.ADD_ADDRESS_LABEL' | translate }}</a>
          </div>
        </div>

        <div class="loading-overlay" *ngIf="isLoading">
          <div class="loader-wrp">
            <div class="loader"><span></span><span></span><span></span></div>
            <p> {{ 'LOADING' | translate }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>

</div>